import React from "react";
import { isVideov2 } from "../../helpers/isVideo";

function StaticSlider({ product }) {
  const mediaDefault = product.imageBackground ? product.imageBackground[0] : '';

  const getMediaUrlByScreenSize = () => {
    const windowWidth = window.innerWidth;
    let media;

    switch (true) {
      case windowWidth < 575:
        media = product.imageBackground_mobile ? product.imageBackground_mobile[0] : '';
        break;
      case windowWidth >= 576 && windowWidth < 1200:
        media = product.imageBackground_tablet ? product.imageBackground_tablet[0] : '';
        break;
      default:
        media = mediaDefault;
    }
    return media;
  };

  const media = getMediaUrlByScreenSize();
  const isVideoCover = isVideov2( media?.url )
  
  return (
    <>
      <div id="maqueta" className="bg-fullpage bg_products">
        <picture className="bg-fullpage bg_products">
          { isVideoCover ? (
              <video
                src={ media ? media?.url : mediaDefault?.url }
                autoPlay
                muted
                loop
                style={{
                  width: '100%',
                  height: '100vh', 
                  objectFit: 'cover', 
                  objectPosition: 'center', 
                }}
              />
            ) : (
              <img
            className="imagen-prodLinea"
            src={ media ? media?.url : mediaDefault?.url}
            alt={ media ? media?.alt : mediaDefault?.alt}
            title={product?.title}
            loading="lazy"
          />
            )}
        </picture>
      </div>
    </>
  );
}

export default StaticSlider;
